import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { withTranslation } from 'react-i18next';
import { Row } from 'react-bootstrap';

const SpinnerExport = (props) => {
    const { t } = props;
    return (
        <div className="spinner">
            <Row>{t('messages.common:exportInProgress')}</Row>
            <Row>
                <ThreeDots
                    height="100"
                    width="100"
                    color="#0052cc"
                    visible={true}
                />
            </Row>
        </div>
    );
};

export default withTranslation()(SpinnerExport);